import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { sortedUniq, compact } from 'lodash';

import User from './User';

class Users extends Component {
  render() {
    const { users, presence = {}, allUsers } = this.props;
    const userIdsPresent = allUsers
      ? Object.keys(users)
      : compact(
          Object.values(presence)
            // we send presence objects with userid as undefined when we
            // don't want observers to show up, but just trigger other users
            // to reply with their presence. Here we are filtering those users
            .map((user) => user.u)
        );

    // we don't want user avatars to jump around when new users are added,
    // so we specifically sort the array to make sure it is predictable
    userIdsPresent.sort();

    // if the same user is logged in twice, they will have two presence objects,
    // but we only want to show one avatar, so we do the set of user IDs. We can
    // use sortedUniq, since it's already been sorted
    const userIdsSetPresent = sortedUniq(userIdsPresent);

    return (
      <div className="flex">
        {userIdsSetPresent.map((userId, idx) => (
          <User
            key={userId}
            {...users[userId]}
            border={!allUsers}
            displace={idx !== 0}
          />
        ))}
      </div>
    );
  }
}

Users.propTypes = {
  users: PropTypes.object.isRequired,
  presence: PropTypes.object, // required only if allUsers isn't passed
  allUsers: PropTypes.bool, // required only if presence isn't passed
};

export default Users;
